import badSmileyFace from '@/assets/images/meeting-stats-Smiley-bad.svg?react';
import happySmileyFace from '@/assets/images/meeting-stats-Smiley-happy.svg?react';
import mediumSmileyFace from '@/assets/images/meeting-stats-Smiley-medium.svg?react';

export default function getSmileyIcon(percentage: number) {
  if (percentage < 25) return badSmileyFace;
  if (percentage < 50) return mediumSmileyFace;
  return happySmileyFace;
}
